<template>
  <div class="card slim password-requirements-pane">
    <div class="card-header">
      <p>New Password Instructions</p>
    </div>
    <div class="card-body">
      <p v-if="currentPasswordRequired">
        <font-awesome-icon id='currentPasswordLength' :icon="currentLengthValid ? checkedIcon : uncheckedIcon " :aria-label="currentLengthValid ? 'Check' : 'Unchecked'"></font-awesome-icon>
        Enter your current password.
      </p>
      <p>
        <font-awesome-icon id='newPasswordLength' :icon="lengthValid ? checkedIcon : uncheckedIcon " :aria-label="lengthValid ? 'Check' : 'Unchecked'"></font-awesome-icon>
        Your new password must be at least 12 characters and at most 32 characters.
      </p>
      <p>
        <font-awesome-icon id='casing' :icon="caseValid ? checkedIcon : uncheckedIcon " :aria-label="caseValid ? 'Check' : 'Unchecked'"/>
        Your new password must have at least 1 uppercase letter and 1 lowercase letter.
      </p>
      <p class="_mb0">
        <font-awesome-icon id='specialCharacters' :icon="specialCharacterValid ? checkedIcon : uncheckedIcon " :aria-label="specialCharacterValid ? 'Check' : 'Unchecked'"/>
        Your new password must have at least 1 number.
      </p>
      <p>
        <font-awesome-icon id='confirmedPassword' :icon="passwordsMatch ? checkedIcon : uncheckedIcon " :aria-label="passwordsMatch ? 'Check' : 'Unchecked'"/>
        You have confirmed your new password.
      </p>
    </div>
  </div>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

  export default {
    components: {
      FontAwesomeIcon
    },
    props: {
      currentPasswordRequired: {
        type: Boolean,
        default: false
      },
      currentPassword: {
        type: String,
        default: ''
      },
      newPassword: {
        type: String,
        default: ''
      },
      confirmNewPassword: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        // Validation icons
        checkedIcon: 'check-circle',
        uncheckedIcon: 'times-circle',

        // Validation Checks:
        lengthValid: false,
        caseValid: false,
        specialCharacterValid: false,
        passwordsMatch: false,
        currentLengthValid: false
      }
    },
    methods: {
      validatePassword() {
        this.currentLengthValid = this.currentPasswordRequired ? this.isCurrentLengthValid() : true
        this.lengthValid = this.isNewLengthValid()
        this.caseValid = this.isValidCase()
        this.specialCharacterValid = this.isValidSpecialCharacters()
        this.passwordsMatch = (this.newPassword === this.confirmNewPassword) && (this.lengthValid)
        this.$emit('input', !(
          this.currentLengthValid &&
          this.lengthValid &&
          this.caseValid &&
          this.specialCharacterValid &&
          this.passwordsMatch
        ))
      },
      isCurrentLengthValid() {
        let regex = new RegExp('^.{8,32}$')
        return regex.test(this.currentPassword)
      },
      isNewLengthValid() {
        let regex = new RegExp('^.{12,32}$')
        return regex.test(this.newPassword)
      },
      isValidCase() {
        let regex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])')
        return regex.test(this.newPassword)
      },
      isValidSpecialCharacters() {
        let regex = new RegExp('[0-9]') // Special characters are not required by LDAP, just numbers.
        // let regex = new RegExp('[0-9]|[!@#\$%\^&\*\+]')
        return regex.test(this.newPassword)
      }
    },
    watch: {
      'currentPassword' () {
        this.validatePassword()
      },

      'newPassword' () {
        this.validatePassword()
      },

      'confirmNewPassword' () {
        this.validatePassword()
      }
    }
  }
</script>